import queryString from "query-string";
import { useEffect, useState } from "react";

import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import {
  companyObject,
  objectFromResponseData,
} from "../company components/company details components/companyDetailsObject";
import FormDisplay from "./unverified company details/FormDisplay";

export default function UnverifiedCompanyDetails() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [editState, setEditState] = useState(true);
  const [noDetails, setNoDetails] = useState(false);
  const [formData, setFormData] = useState(companyObject);
  const brandID = queryString.parse(window.location.search).brandID;

  useEffect(() => {
    loader.start(1);
    if (formData.ID) {
      setEditState(false);
    }
    if (!!brandID) {
      axios({
        url: "/getCompany/" + brandID,
      }).then((response) => {
        if (response.status) {
          if (Object.keys(response.data).length > 0) {
            if (response.data.is_brand_verified === 0) {
              setEditState(false);
            }
            setFormData(objectFromResponseData(response.data));
          }
          loader.stop();
        } else {
          setNoDetails(true);
          setFormData(companyObject);
          loader.stop();
        }
      });
    } else {
      loader.stop();
    }
  }, [axios, brandID, formData.ID, loader]);

  return (
    <Loader>
      <FormDisplay
        brandID={brandID}
        setEditState={setEditState}
        editState={editState}
        noDetails={noDetails}
        formData={formData}
        setFormData={setFormData}
      />
    </Loader>
  );
}
